/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LinkDisplayType {
  Primary = 'PRIMARY',
  Ordinary = 'ORDINARY'
}
